<script lang="ts">
  import { Card, ErrorView, InfoView, List } from '$shared/components';
  import type { PrintData } from '$shared/models/PrintData';
  import MetaInfo from './MetaInfo.svelte';
import { ListStyle } from '$shared/constants/ListStyle';

  interface Props {
    data: PrintData;
  }

  let { data }: Props = $props();
</script>

<div class="result-section">
  <div class="title">Result</div>
  <MetaInfo
    lastUpdated={data.lastUpdated}
    isFailed={data.isFailed}
    verifiedOn={data.verifiedOn}
    completedOn={data.completedOn}
  />
  <div class="list">
    <Card nospace>
      {#if data.resultInfo}
        <div class="result">
          <InfoView label={data.resultInfo} />
        </div>
      {:else if data.isNotFound}
        <ErrorView label={'No Match Found'} />
      {:else}
        {#each data.results as list}
          <div class="list-i">
            {#if list.__title || list.__meta?.name}
              <div class="list-title">{list.__title || list.__meta?.name}</div>
            {/if}
            <List problems={list.__meta?.problems} style={ListStyle.Compact} {list} />
          </div>
        {/each}
      {/if}
    </Card>
  </div>
</div>

<style>
  .title {
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: var(--grey-black);
  }
  .list {
    margin-top: 8px;
  }
  .list .list-title {
    margin-bottom: 16px;
    margin-top: 16px;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    padding-left: 16px;
  }
  .list .list-i:not(:last-child) {
    margin-bottom: 24px;
  }
</style>
